import { Box, BoxProps } from '@chakra-ui/react';

import styled from '@emotion/styled';

export const LandingWrapper = styled((props: BoxProps) => (
  <Box maxWidth={'1080px'} margin={'0 auto'} {...props} />
))``;
